import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import src from "./not-found.png";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 40%;
    width: 100%;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    font-family: urdu, QuranFont, Roboto, sans-serif;
`;
const A = styled.a`
    display: block;
    margin-top: 40px;
`;
const Img = styled.img`
    width: 266px;
    height: 92px;
`;

export function NoResults({ message }: { message: string }) {
    return (
        <Container>
            <FormattedMessage id={message} />

            <A href="https://www.facebook.com/urdupub/" target="_blank">
                <Img src={src} />
            </A>
        </Container>
    );
}
